import { t as SystemStatus } from "./status-ChiHYKYc.mjs";

//#region src/components/statusAlert.ts
const STATUS_CONFIGS = {
	[SystemStatus.UnderMaintenance]: {
		background: "#e7f1fc",
		color: "#072742",
		borderColor: "#339af0",
		icon: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="oops-widget-icon">
      <path stroke-linecap="round" stroke-linejoin="round" d="M11.42 15.17 17.25 21A2.652 2.652 0 0 0 21 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 1 1-3.586-3.586l6.837-5.63m5.108-.233c.55-.164 1.163-.188 1.743-.14a4.5 4.5 0 0 0 4.486-6.336l-3.276 3.277a3.004 3.004 0 0 1-2.25-2.25l3.276-3.276a4.5 4.5 0 0 0-6.336 4.486c.091 1.076-.071 2.264-.904 2.95l-.102.085m-1.745 1.437L5.909 7.5H4.5L2.25 3.75l1.5-1.5L7.5 4.5v1.409l4.26 4.26m-1.745 1.437 1.745-1.437m6.615 8.206L15.75 15.75M4.867 19.125h.008v.008h-.008v-.008Z" />
    </svg>`,
		className: "under-maintenance",
		progressColor: "rgba(51, 154, 240, 0.5)"
	},
	[SystemStatus.DegradedPerformance]: {
		background: "#fff3cd",
		color: "#6a4a02",
		borderColor: "#ffcf57",
		icon: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="oops-widget-icon">
      <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 6 9 12.75l4.286-4.286a11.948 11.948 0 0 1 4.306 6.43l.776 2.898m0 0 3.182-5.511m-3.182 5.51-5.511-3.181" />
    </svg>`,
		className: "degraded-performance",
		progressColor: "rgba(255, 207, 87, 0.6)"
	},
	[SystemStatus.PartialOutage]: {
		background: "#ffebd6",
		color: "#6f3500",
		borderColor: "#ffae6d",
		icon: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="oops-widget-icon">
      <path stroke-linecap="round" stroke-linejoin="round" d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0M3.124 7.5A8.969 8.969 0 0 1 5.292 3m13.416 0a8.969 8.969 0 0 1 2.168 4.5" />
    </svg>`,
		className: "partial-outage",
		progressColor: "rgba(255, 174, 109, 0.5)"
	},
	[SystemStatus.MajorOutage]: {
		background: "#f8d7da",
		color: "#6f1c27",
		borderColor: "#dc3545",
		icon: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="oops-widget-icon">
      <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
    </svg>`,
		className: "major-outage",
		progressColor: "rgba(220, 53, 69, 0.5)"
	}
};
const DEFAULT_STATUS = SystemStatus.DegradedPerformance;
var StatusAlert = class extends HTMLElement {
	shadow;
	closeButtonListener;
	constructor() {
		super();
		this.shadow = this.attachShadow({ mode: "open" });
	}
	static get observedAttributes() {
		return [
			"status-type",
			"title",
			"message",
			"slide-direction",
			"mobile-enabled",
			"mobile-placement",
			"placement",
			"data-mobile-media-query",
			"progress-duration",
			"incident-names",
			"incident-statuses",
			"incident-links",
			"display-incident-details",
			"close-button-label"
		];
	}
	connectedCallback() {
		this.render();
		this.attachEventListeners();
		this.updateProgressAnimation();
	}
	disconnectedCallback() {
		this.detachEventListeners();
	}
	attributeChangedCallback(name, oldValue, newValue) {
		if (oldValue !== newValue) {
			this.detachEventListeners();
			if (name === "progress-duration") {
				this.render();
				this.updateProgressAnimation();
			} else this.render();
			this.attachEventListeners();
		}
	}
	get statusType() {
		return this.getAttribute("status-type") || DEFAULT_STATUS;
	}
	get alertTitle() {
		return this.getAttribute("title") || "Status Update";
	}
	get message() {
		return this.getAttribute("message") || "";
	}
	get mobileEnabled() {
		return this.getAttribute("mobile-enabled") === "true";
	}
	get mobilePlacement() {
		return this.getAttribute("mobile-placement") || "top";
	}
	get placement() {
		return this.getAttribute("placement") || "top-right";
	}
	get customMediaQuery() {
		return this.getAttribute("data-mobile-media-query") || "(max-width: 768px)";
	}
	get config() {
		return STATUS_CONFIGS[this.statusType] || STATUS_CONFIGS[DEFAULT_STATUS];
	}
	get incidentNames() {
		const namesAttr = this.getAttribute("incident-names");
		if (!namesAttr) return [];
		try {
			return JSON.parse(namesAttr);
		} catch {
			return [];
		}
	}
	get incidentStatuses() {
		const statusesAttr = this.getAttribute("incident-statuses");
		if (!statusesAttr) return [];
		try {
			return JSON.parse(statusesAttr);
		} catch {
			return [];
		}
	}
	get incidentLinks() {
		const linksAttr = this.getAttribute("incident-links");
		if (!linksAttr) return [];
		try {
			return JSON.parse(linksAttr);
		} catch {
			return [];
		}
	}
	get displayIncidentDetails() {
		return this.getAttribute("display-incident-details") === "true";
	}
	get closeButtonLabel() {
		return this.getAttribute("close-button-label") || "Close alert";
	}
	escapeHtml(unsafe) {
		if (!unsafe) return "";
		return unsafe.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
	}
	getIncidentDetailsHtml() {
		const names = this.incidentNames;
		const statuses = this.incidentStatuses;
		const links = this.incidentLinks;
		if (!this.displayIncidentDetails || !names.length) return "";
		let detailsHtml = "<div class=\"oops-widget-incidents\">";
		names.forEach((name, index) => {
			const escapedName = this.escapeHtml(name);
			const status = statuses[index] ? this.escapeHtml(statuses[index]) : "";
			const link = links[index] || "";
			const validUrl = link && /^https?:\/\//i.test(link) ? this.escapeHtml(link) : "";
			detailsHtml += "<div class=\"oops-widget-incident\">";
			if (status) detailsHtml += `<span class="oops-widget-incident-status">${status}</span>`;
			if (validUrl) detailsHtml += `<a href="${validUrl}" target="_blank" rel="noopener noreferrer" class="oops-widget-incident-link">
          ${escapedName}
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="oops-widget-external-link-icon">
            <path fill-rule="evenodd" d="M4.25 5.5a.75.75 0 0 0-.75.75v8.5c0 .414.336.75.75.75h8.5a.75.75 0 0 0 .75-.75v-4a.75.75 0 0 1 1.5 0v4A2.25 2.25 0 0 1 12.75 17h-8.5A2.25 2.25 0 0 1 2 14.75v-8.5A2.25 2.25 0 0 1 4.25 4h5a.75.75 0 0 1 0 1.5h-5Z" clip-rule="evenodd" />
            <path fill-rule="evenodd" d="M6.194 12.753a.75.75 0 0 0 1.06.053L16.5 4.44v2.81a.75.75 0 0 0 1.5 0v-4.5a.75.75 0 0 0-.75-.75h-4.5a.75.75 0 0 0 0 1.5h2.553l-9.056 8.194a.75.75 0 0 0-.053 1.06Z" clip-rule="evenodd" />
          </svg>
        </a>`;
			else detailsHtml += `<span class="oops-widget-incident-text">${escapedName}</span>`;
			detailsHtml += "</div>";
		});
		detailsHtml += "</div>";
		return detailsHtml;
	}
	attachEventListeners() {
		const closeBtn = this.shadow.querySelector(".oops-widget-close-btn");
		if (closeBtn) {
			this.closeButtonListener = () => {
				this.dispatchEvent(new CustomEvent("oops-widget-closed", {
					bubbles: true,
					composed: true
				}));
				this.remove();
			};
			closeBtn.addEventListener("click", this.closeButtonListener);
		}
		this.addEventListener("oops-widget-timer-start", this.handleTimerStart);
		this.addEventListener("oops-widget-timer-cancel", this.handleTimerCancel);
	}
	detachEventListeners() {
		const closeBtn = this.shadow.querySelector(".oops-widget-close-btn");
		if (closeBtn && this.closeButtonListener) closeBtn.removeEventListener("click", this.closeButtonListener);
		this.removeEventListener("oops-widget-timer-start", this.handleTimerStart);
		this.removeEventListener("oops-widget-timer-cancel", this.handleTimerCancel);
	}
	updateProgressAnimation(durationMs) {
		const popup = this.shadow.querySelector(".oops-widget-popup");
		if (!popup) return;
		popup.classList.remove("has-progress");
		if (durationMs && durationMs > 0) {
			popup.style.setProperty("--progress-duration-ms", `${durationMs}ms`);
			popup.offsetWidth;
			requestAnimationFrame(() => {
				popup.classList.add("has-progress");
			});
		} else popup.style.removeProperty("--progress-duration-ms");
	}
	render() {
		const mediaQueryString = this.mobileEnabled ? this.customMediaQuery : "screen and (max-width: 0px)";
		this.shadow.innerHTML = `
      <style>
        :host {
          --oops-widget-bg: ${this.config.background};
          --oops-widget-color: ${this.config.color};
          --oops-widget-border-color: ${this.config.borderColor};
          --oops-widget-progress-color: ${this.config.progressColor};
          --progress-duration-ms: 0ms;
          --oops-widget-font: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
          --oops-widget-line-height: 1.4;
          --oops-widget-shadow: 0 2px 12px rgba(0, 0, 0, 0.08), 0 4px 24px rgba(0, 0, 0, 0.06);
          --oops-widget-radius: 8px;
          --oops-widget-border-width: 3px;
        }
        
        .oops-widget-popup {
          width: 360px;
          padding: 14px 16px;
          border-radius: var(--oops-widget-radius);
          box-shadow: var(--oops-widget-shadow);
          display: flex;
          flex-direction: column;
          font-family: var(--oops-widget-font);
          font-size: 14px;
          line-height: var(--oops-widget-line-height);
          background-color: var(--oops-widget-bg);
          color: var(--oops-widget-color);
          border-left: var(--oops-widget-border-width) solid var(--oops-widget-border-color);
          overflow: hidden;
          pointer-events: auto;
          position: fixed;
          z-index: 9999;
          box-sizing: border-box;
          backdrop-filter: blur(8px);
        }
        
        .placement-top-right {
          top: 14px;
          right: 14px;
        }
        .placement-top-left {
          top: 14px;
          left: 14px;
        }
        .placement-bottom-right {
          bottom: 14px;
          right: 14px;
        }
        .placement-bottom-left {
          bottom: 14px;
          left: 14px;
        }
        
        @media ${mediaQueryString} {
          .oops-widget-popup {
            width: 100%;
            max-width: 100%;
            border-radius: 0;
            position: fixed;
            right: 0;
            left: 0;
            border-left: none;
            padding: 14px 18px;
            box-shadow: 0 1px 18px rgba(0, 0, 0, 0.12);
            z-index: 9999;
            box-sizing: border-box;
          }
          
          .mobile-placement-top {
            top: 0;
            bottom: auto;
            padding-top: max(14px, env(safe-area-inset-top));
            padding-bottom: 14px;
            border-bottom: var(--oops-widget-border-width) solid var(--oops-widget-border-color);
            border-top: none;
          }
          .mobile-placement-bottom {
            bottom: 0;
            top: auto;
            padding-bottom: max(14px, env(safe-area-inset-bottom));
            padding-top: 14px;
            border-top: var(--oops-widget-border-width) solid var(--oops-widget-border-color);
            border-bottom: none;
          }
          
          .oops-widget-popup {
            padding-left: max(18px, env(safe-area-inset-left));
            padding-right: max(18px, env(safe-area-inset-right));
          }
        }
        
        .oops-widget-incidents {
          margin-top: 12px;
          border-top: 1px solid rgba(0, 0, 0, 0.07);
          padding-top: 10px;
          font-size: 13px;
        }
        
        .oops-widget-incident {
          display: flex;
          flex-direction: column;
          margin-bottom: 8px;
          line-height: 1.4;
        }
        
        .oops-widget-incident:last-child {
          margin-bottom: 0;
        }
        
        .oops-widget-incident-link, 
        .oops-widget-incident-text {
          word-break: break-word;
          display: flex;
          align-items: center;
          gap: 4px;
          color: var(--oops-widget-color);
          text-decoration: none;
          font-weight: 500;
        }
        
        .oops-widget-incident-link {
          text-decoration: underline;
          text-decoration-thickness: 1px;
          text-underline-offset: 2px;
          transition: all 0.15s ease;
        }
        
        .oops-widget-incident-link:hover {
          text-decoration-thickness: 2px;
          opacity: 0.85;
        }
        
        .oops-widget-incident-status {
          background: rgba(0, 0, 0, 0.06);
          padding: 2px 8px;
          border-radius: 12px;
          font-size: 11px;
          margin-bottom: 4px;
          display: inline-block;
          width: fit-content;
          font-weight: 600;
          letter-spacing: 0.01em;
          text-transform: uppercase;
        }
        
        .oops-widget-external-link-icon {
          width: 11px;
          height: 11px;
          flex-shrink: 0;
          opacity: 0.8;
        }
        
        .oops-widget-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-weight: 600;
          font-size: 15px;
          letter-spacing: -0.01em;
        }
        
        .oops-widget-header span {
          display: flex;
          align-items: center;
          gap: 8px;
        }
        
        .oops-widget-icon { 
          width: 20px; 
          height: 20px; 
          flex-shrink: 0; 
          opacity: 0.9;
        }
        
        .oops-widget-title { 
          word-break: break-word; 
          overflow-wrap: break-word;
          line-height: 1.3;
          letter-spacing: -0.01em;
        }
        
        .oops-widget-message {
          color: rgba(0, 0, 0, 0.7);
          margin-top: 6px;
          word-wrap: break-word;
          overflow-wrap: break-word;
          line-height: 1.45;
          font-size: 13.5px;
          letter-spacing: -0.01em;
        }
        
        .oops-widget-close-btn {
          background: none;
          border: none;
          cursor: pointer;
          color: inherit;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 6px;
          margin: -6px;
          border-radius: 6px;
          transition: background-color 0.2s ease;
          opacity: 0.65;
        }
        
        .oops-widget-close-btn:hover {
          background-color: rgba(0, 0, 0, 0.06);
          opacity: 0.8;
        }
        
        .oops-widget-close-icon { 
          width: 15px; 
          height: 15px; 
        }
        
        @media ${mediaQueryString} {
          .oops-widget-close-btn {
            padding: 8px;
            margin: -8px;
            background-color: rgba(0, 0, 0, 0.05);
            border-radius: 6px;
            transition: background-color 0.2s ease;
            position: relative;
            min-width: 32px;
            min-height: 32px;
          }
          
          .oops-widget-close-btn:hover, 
          .oops-widget-close-btn:active { 
            background-color: rgba(0, 0, 0, 0.08); 
          }
          
          .oops-widget-close-btn::before {
            content: "";
            position: absolute;
            top: -6px;
            right: -6px;
            bottom: -6px;
            left: -6px;
            border-radius: 6px;
          }
          
          .oops-widget-close-icon { 
            width: 18px; 
            height: 18px; 
          }
          
          .oops-widget-header { 
            padding: 2px 0; 
          }
          
          .oops-widget-message {
            font-size: 13px;
            line-height: 1.45;
            margin-top: 8px;
            max-width: 100%;
            overflow-wrap: break-word;
            word-break: break-word;
          }
          
          .oops-widget-icon { 
            width: 20px; 
            height: 20px; 
          }
          
          .oops-widget-header span {
            font-size: 15px;
            line-height: 1.3;
            flex-wrap: wrap;
            word-break: break-word;
            max-width: calc(100% - 40px);
          }
        }
        
        @keyframes fillBar {
          0% { width: 0; }
          100% { width: 100%; }
        }
        
        .oops-widget-popup::after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
          height: 3px;
          width: 0;
          background-color: var(--oops-widget-progress-color);
          border-radius: 0 0 0 2px;
          transform-origin: left center;
          will-change: width, transform;
          transition: width 0.3s ease-out;
        }
        
        .oops-widget-popup.has-progress::after {
          width: 0;
          animation: fillBar linear forwards;
          animation-duration: var(--progress-duration-ms);
        }
        
        @media ${mediaQueryString} {
          .oops-widget-popup.mobile-placement-bottom::after {
            top: 0;
            bottom: auto;
            border-radius: 2px 0 0 0;
          }
        }
      </style>
      <div 
        class="oops-widget-popup ${this.config.className} placement-${this.placement} ${this.mobileEnabled ? "mobile-mode" : ""} ${this.mobileEnabled ? "mobile-placement-" + this.mobilePlacement : ""}" 
        part="popup"
        role="alert" 
        aria-labelledby="oops-widget-title-id"
        aria-live="assertive"
      >
        <div class="oops-widget-header" part="header">
          <span>
            ${this.config.icon}
            <div class="oops-widget-title" id="oops-widget-title-id">${this.escapeHtml(this.alertTitle)}</div>
          </span>
          <button 
            class="oops-widget-close-btn" 
            part="close" 
            aria-label="${this.escapeHtml(this.closeButtonLabel)}"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="oops-widget-close-icon" aria-hidden="true">
              <path fill-rule="evenodd" d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd"/>
            </svg>
          </button>
        </div>
        <div class="oops-widget-message" part="message">${this.escapeHtml(this.message)}</div>
        ${this.getIncidentDetailsHtml()}
      </div>
    `;
		this.updateProgressAnimation();
	}
	handleTimerStart = (event) => {
		const duration = event.detail?.duration;
		if (typeof duration === "number" && duration > 0) {
			this.updateProgressAnimation(0);
			requestAnimationFrame(() => {
				requestAnimationFrame(() => {
					this.updateProgressAnimation(duration);
				});
			});
		}
	};
	handleTimerCancel = () => {
		this.updateProgressAnimation();
	};
};

//#endregion
export { StatusAlert };